import * as api from '../api';
import { 
  RECEIVE_PRODUCTS, 
  RECEIVE_PRODUCTS_BY_CATEGORY,
  RECEIVE_PRODUCT_BY_SLUG,
  RECEIVE_DELIVERY_COST_ON_PRODUCT,
  RECEIVE_SEARCH_PRODUCT,
  RECEIVE_PRODUCT_LAST_PRICE,
  RECEIVE_PRODUCT_PRICE_HISTORY,
  SHOW_QUICKVIEW, 
  HIDE_QUICKVIEW 
} from '../constants/action-types';

export const getProducts = () => dispatch => {
  api.getAllProducts().then(products => {
      dispatch(receiveProducts(products));
      return products;
  })
}

export const getProductsByCategory = (slug, setProductsByCat) => dispatch => {
  api.getProductsByCategorySlug(slug, setProductsByCat).then(productsByCategory => {
      dispatch(receiveProductsByCategory(productsByCategory));
      return productsByCategory;
  })
}

export const getProductBySlug = (slug, setProductBySlug) => dispatch => {
  api.getProductBySlug(slug, setProductBySlug).then(productBySlug => {
      dispatch(receiveProductBySlug(productBySlug));
      return productBySlug;
  })
}

export const getProductLastPrice = (slug) => dispatch => {
  api.getProductLastPrice(slug).then(productLastPrice => {
      dispatch(receiveProductLastPrice(productLastPrice));
      return productLastPrice;
  })
}

export const getProductPriceHistory = (slug) => dispatch => {
  api.getProductPriceHistory(slug).then(productPriceHistory => {
      dispatch(receiveProductPriceHistory(productPriceHistory));
      return productPriceHistory;
  })
}

export const getProductImages = (product_id, setImg) => dispatch => {
  api.getProductImages(product_id, setImg).then(productImg => {
      return productImg;
  })
}

export const getOnProductDeliveryCost = (branch_id, address_post) => dispatch => {
  api.getOnProductDeliveryCost(branch_id, address_post).then(productDeliveryCost => {
      dispatch(receiveProductDeliveryCost(productDeliveryCost));
      return productDeliveryCost;
  })
}

export const searchProducts = (searchInput, setIsLoading, setProductsSearch) => dispatch => {
  api.searchProducts(searchInput, setIsLoading, setProductsSearch).then(searchProducts => {
      dispatch(receiveSearchProduct(searchProducts));
      return searchProducts;
  })
}

export const receiveProducts = products => ({
  type: RECEIVE_PRODUCTS,
  products
});

export const receiveProductsByCategory = productsByCategory => ({
  type: RECEIVE_PRODUCTS_BY_CATEGORY,
  productsByCategory
});

export const receiveProductBySlug = productBySlug => ({
  type: RECEIVE_PRODUCT_BY_SLUG,
  productBySlug
});

export const receiveProductLastPrice = productLastPrice => ({
  type: RECEIVE_PRODUCT_LAST_PRICE,
  productLastPrice
});

export const receiveProductPriceHistory = productPriceHistory => ({
  type: RECEIVE_PRODUCT_PRICE_HISTORY,
  productPriceHistory
});

export const receiveProductDeliveryCost = productDeliveryCost => ({
  type: RECEIVE_DELIVERY_COST_ON_PRODUCT,
  productDeliveryCost
});

export const receiveSearchProduct = searchProducts => ({
  type: RECEIVE_SEARCH_PRODUCT,
  searchProducts
});

export const showQuickView = (product) => ({
  type: SHOW_QUICKVIEW,
  product
})

export const hideQuickView = () => dispatch => {
  dispatch({ type: HIDE_QUICKVIEW });
}

// export const getProduct = productId => ({
//   type: FETCH_SINGLE_PRODUCT,
//   productId
// })